import {
  useIsAnomaliesTrendVisible,
  useIsSingleRecordQuery,
} from '@modules/quantify/hooks';
import { UUID } from 'v2/core/entities/uuid';
import { useDashboardStore } from '../store/useDashboardStore';

export const useShouldShowDashboardQuantifyAsTable = (analysisID: UUID) => {
  const shouldShowAnomaliesAsChart = useDashboardStore(
    ({ metadata }) =>
      metadata.analysesMetadata.find((metadata) => metadata.id === analysisID)
        ?.shouldShowAnomaliesAsChart,
  );
  const shouldShowAsTable = useDashboardStore(
    ({ metadata }) =>
      metadata.analysesMetadata.find((metadata) => metadata.id === analysisID)
        ?.shouldShowAsTable,
  );

  const isAnomaliesTrendVisible = useIsAnomaliesTrendVisible();
  const isSingleRecordQuery = useIsSingleRecordQuery();

  if (isSingleRecordQuery) {
    return false;
  }

  if (!isAnomaliesTrendVisible) {
    return Boolean(shouldShowAsTable);
  }

  // To support dashboards that have 'shouldShowAnomaliesAsChart' metadata
  // TODO: Remove when we deprecate 'shouldShowAnomaliesAsChart' & migrate to `shouldShowAsTable` from BE
  if (typeof shouldShowAnomaliesAsChart === 'boolean') {
    return !shouldShowAnomaliesAsChart;
  }

  return shouldShowAsTable ?? true; // Anomalies are shown as table by default
};
